import { Box, Flex, Text, Image, Badge, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Input, InputGroup, InputLeftElement, Button, Grid, GridItem, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Center, Spinner, useDisclosure, Tooltip, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Divider, IconButton, FormErrorMessage, Popover, PopoverTrigger } from "@chakra-ui/react";
import { MyDiv, CallModal } from "./candidateList.style";
import ArrowIcon from "../../../../assets/images/ActionArrow.svg";
import { useNavigate } from "react-router";
import * as routesNames from "../../../../constants/routes";
import { ActionEditIcon, CustomButton, CustomPagination, CustomTable, CustomToast, FilterPopover } from "../../../../components";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useEffect, useRef, useState } from "react";
import UploadLogo from "../../../../assets/images/UploadLogo.svg";
import { useLocation } from "react-router-dom";
import { baseUrl, ILazyParams, useFetch } from "../../../../hooks/useFetch";
import { Controller, Resolver, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { HrlenseInput } from "../../../../components/Input/Input";
import { Dropdown } from "../../../../components/DropDown/DropDown";
import { ICandidateForm, IWorkModeDropdown, candidateSchema, emptyCandidateForm, experince, hiringCategoryList } from "./modal";
import { Column } from "../../../../components/CustomTable/customTable";
import ScheduleMultipleInterview from "./ScheduleMultipleInterview";
import BulkExcellUpload from "./BulkExcellUpload";
import BulkResumeUpload from "./BulkResumeUpload";
import EditCandidateDetails from "./EditCandidateDetails";
import { showDate } from "../../../../utilities/helper";
import { PhoneIcon, SearchIcon, TimeIcon } from "@chakra-ui/icons";
import CallImage from "../../../../assets/images/CallImage.svg"
import AudioPlayIcon from "../../../../assets/images/AudioPlayIcon.svg"
import { useAuth } from "../../../../hooks/useAuth";
import { IFilterOptions } from "../../../../components/FilterCard/filterCard";
import FilterIcon from '../../../../assets/images/Filter.svg';


export const CandidateList = () => {
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [resumeFile, setResumeFile] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [candidateList, setCandidateList] = useState<any[]>([]);
  const [isExperienceCheck, setIsExperienceCheck] = useState<boolean>(false);
  const [workModeList, setWorkModeList] = useState<IWorkModeDropdown[]>([]);
  const [selectedCandidates, setSelectedCandidates] = useState<number[]>([]);

  const location = useLocation();
  const { jobId: stateJobId, Job_profile, hideAddButton, filterType } = location.state || {};
  const { search } = location;
  const params = new URLSearchParams(search);
  const queryJobId = params.get("jobId");
  const jobId = stateJobId || queryJobId;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCandidateDetails, setSelectedCandidateDetails] = useState<any[]>([]);
  const [excellUploadModalOpen, setExcellUploadModalOpen] = useState(false);
  const [resumeUploadModalOpen, setResumeUploadModalOpen] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedCandidate, setSelectedCandidate] = useState<any>(null);
  const [interviewDetailsModal, setInterviewDetailsModal] = useState(false);
  const [selectedInterviewDetails, setSelectedInterviewDetails] = useState<any>(null);
  const [callModalOpen, setCallModalOpen] = useState(false);
  const [callingCandidate, setCallingCandidate] = useState<any>(null);
  const [isCalling, setIsCalling] = useState(false);
  const [historyDrawer, setHistoryDrawer] = useState(false);
  const [callHistory, setCallHistory] = useState<any[]>([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [historyCandidate, setHistoryCandidate] = useState<any>(null);
  const [audioModalOpen, setAudioModalOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [audioUrl, setAudioUrl] = useState("");
  const [audioLoading, setAudioLoading] = useState(false);
  const [loadingRecording, setLoadingRecording] = useState<string | null>(null);
  const { loginObj, hasPermission, employeeId } = useAuth();
  const ivrAccess = hasPermission("CandidateMaster", "IVR Calling");
  const [genderList, setGenderList] = useState<any[]>([]);
  const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });
  const [totalCount, setTotalCount] = useState<number>(0);


  const [query, setQuery] = useState<{ lazyParams: ILazyParams, filter?: Record<string, number[]>; }>({
    lazyParams: { first: 0, rows: 20, page: 0, sortField: '', sortOrder: 1 },
    filter: {},
  });

  const { handleSubmit, control, formState: { errors }, reset, watch, } = useForm<ICandidateForm>({
    resolver: yupResolver(candidateSchema) as Resolver<ICandidateForm>,
    defaultValues: emptyCandidateForm,
    mode: "onBlur",
  });


  const pageCount = Math.ceil(totalCount / query.lazyParams.rows);
  const handlePageClick = ({ selected }: { selected: number }) => {
    setQuery(prev => {
      const updatedParams = {
        ...prev.lazyParams,
        page: selected,
        first: selected * prev.lazyParams.rows,
      };
      return { ...prev, lazyParams: updatedParams };
    });
  };

  const setRowsPerPage = (rows: number) => {
    setQuery((prev) => {
      const updatedParams = {
        ...prev.lazyParams,
        rows,
        page: 0,
        first: 0,
      };
      return { ...prev, lazyParams: updatedParams };
    });
  };

  async function LoadCandidateFilter() {
    const response = await fetchApi<IFilterOptions>('Filters/CandidateFilter', 'GET', null, null, '');
    if (response) {
      setFilter(response);
    }
  }


  const handleScheduleInterview = () => {
    const selectedDetails = candidateList.filter((c) => selectedCandidates.includes(c.id));
    setSelectedCandidateDetails(selectedDetails);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCandidates([]);
  };


  const handleFileClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: any) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      if (file.size > 2 * 1024 * 1024) {
        addToast({ message: "File size should not exceed 2 MB", status: "error" });
        e.target.value = "";
        setResumeFile(null);
        return;
      }
      setResumeFile(file);
    }
  };

  const navigate = useNavigate();
  const candidateDetails = (candidate: any) => {
    navigate(routesNames.CANDIDATEDETAILS, { state: { candidate_Id: candidate.id, candidate_Name: candidate.candidate_Name, job_Profile: candidate.job_Profile_Name, jobId: jobId } });
  };

  const onSubmit = async (data: ICandidateForm) => {
    if (!resumeFile) {
      addToast({ message: "Please Upload resume", status: "error" })
      return;
    }
    const { confirm_email, ...payload } = data;
    const formData = new FormData();
    formData.append("resume", resumeFile as Blob);
    formData.append("data", JSON.stringify({ ...payload, job_Id: jobId }));

    const response = await fetchApi("Candidate", "POST", formData, "", "", true);
    if (response) {
      setDrawerOpen(false);
      reset(emptyCandidateForm);
      setResumeFile(null);
      loadCandidateList();
      addToast({ message: "New Candidate Added Successfully", status: "success" });
    }
  }
  const loadCandidateList = async (searchText ='') => {
    const queryParams = new URLSearchParams({
      lazyParams: JSON.stringify(query.lazyParams),
      filter: JSON.stringify(query.filter ?? {}),
      search: searchText.trim() === "" ? "" : searchText,
      jobId: jobId,
      filterType: filterType ? filterType : ""
    })

    const response = await fetchApi("Candidate", "GET", "", queryParams.toString(), "");
    if (response) {
      setCandidateList(response.data);
      setTotalCount(response.totalCount)
    }
  }

  const loadWorkMode = async () => {
    const response = await fetchApi("RecruitmentMaster/WorkMood", "GET", "", "", "");
    if (response) {
      setWorkModeList(response);
    }
  }

  useEffect(() => {
      const delayDebounce = setTimeout(() => {
        loadCandidateList(searchText);
      }, 400);
  
      return () => clearTimeout(delayDebounce);
    }, [searchText]);


  useEffect(() => {
    loadCandidateList();
  }, [query])


  useEffect(() => {
    loadWorkMode();
    loadGender();
    LoadCandidateFilter();
  }, [])

  useEffect(() => {
    if (jobId) {
      fetchApi("Candidate", "GET", "", `jobId=${jobId}`, "");
    }
  }, [jobId]);


  const watchExperience = watch("experience");
  useEffect(() => {
    if (watchExperience === true) {
      setIsExperienceCheck(true);
    } else {
      setIsExperienceCheck(false);
    }
  }, [watchExperience]);

  const selectableCandidates = candidateList.filter(
    (c: any) => c.status === 1 && c.canWork
  );
  const openCall = (candidate: any) => {
    setCallingCandidate(candidate);
    setCallModalOpen(true);
    setIsCalling(true);
  };

  const endCall = () => {
    setIsCalling(false);
    setTimeout(() => setCallModalOpen(false), 400);
  };
  const triggerCall = async (candidate: any) => {


    const payload = {
      candidateId: candidate.id,
      customerNumber: candidate.phone
    };

    const res = await fetchApi("IVR/click-to-call", "POST", payload, "", "");
    if (res) {
      setCallingCandidate(candidate);
      setCallModalOpen(true);
      setIsCalling(true);
    } else {
      if (!res?.success) {
        // addToast({ message: "Call failed to initiate", status: "error" });
        setIsCalling(false);
        setCallModalOpen(false);
      }
    }

  };

  const openCallHistory = async (candidate: any) => {
    console.log(candidate)
    setHistoryCandidate(candidate);
    setHistoryDrawer(true);
    setHistoryLoading(true);
    const response = await fetchApi("IVR/getCallHistory", "GET", "", `phonenumber=${candidate.phone}`, "");
    if (response) setCallHistory(response);
    else setCallHistory([]);
    setHistoryLoading(false);
  };
  // const playRecording = (url: string) => {
  //   const audio = new Audio(url);
  //   audio.play();
  // };
  const playRecording = async (fileUrl: string) => {
    try {
      setLoadingRecording(fileUrl);
      const response = await fetchApi("IVR/DownloadWav", "GET", "", `fileUrl=${encodeURIComponent(fileUrl)}`, "", false, true);
      if (!response || !response.ok) {
        addToast({ message: "Unable to fetch recording", status: "error" });
        return;
      }

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setAudioUrl(url);
      setAudioModalOpen(true);
    } catch (err) {
      console.error(err);
      addToast({ message: "Error playing recording", status: "error" });
    } finally {
      setLoadingRecording(null);
    }
  };

  const closeAudioModal = () => {
    setAudioModalOpen(false);
    if (audioUrl) {
      URL.revokeObjectURL(audioUrl);
      setAudioUrl("");
    }
  };

  const formatDuration = (sec: number) => {
    if (!sec) return "00:00";
    const m = Math.floor(sec / 60).toString().padStart(2, "0");
    const s = (sec % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };




  const loadGender = async () => {
    const response = await fetchApi("DropDown/Gender", "GET", "", "", "");
    if (response) {
      setGenderList(response);
    }
  }
  return (
    <MyDiv>
      <Flex className="flex_header">
        <Breadcrumb spacing='5px' className="font_poppins text_md text_medium" separator=">>">
          <BreadcrumbItem>
            <BreadcrumbLink className="font_poppins text_md text_medium" href={routesNames.ACTIVEJOBS} color="gray.500">Job Openings</BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage>
            <BreadcrumbLink className="font_poppins text_md text_medium" href='#'>{Job_profile}</BreadcrumbLink>
          </BreadcrumbItem>
        </Breadcrumb>
        <Flex className="filter_section">

          {!hideAddButton && (
            <>
              <Flex className="filter_section">
                <InputGroup maxW="200px">
                  <InputLeftElement pointerEvents="none"> <SearchIcon color="gray.400" /> </InputLeftElement>
                  <Input placeholder="Search Candidate" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                </InputGroup>
              </Flex>

              <Popover placement="bottom-end" closeOnBlur>
                <PopoverTrigger>
                  <Image src={FilterIcon} alt="Filter" className='icon_btn' />
                </PopoverTrigger>
                <FilterPopover filter={filter} onApplyFilter={(filters) => {
                  const _filter: Record<string, number[]> = {};
                  Object.keys(filters).forEach((key) => {
                    if (filters[key].length > 0) {
                      _filter[key.replace(' ', '')] = filters[key];
                    }
                  });
                  setQuery(prev => { return { ...prev, lazyParams: { ...prev.lazyParams, page: 0, first: 0 }, filter: _filter }; });
                }}
                />

              </Popover>

              <CustomButton title="Bulk Upload(Resume)" className="btn abc font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} />} onClick={() => setResumeUploadModalOpen(true)} />
              <CustomButton title="Bulk Upload(Excel)" className="btn abc font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} />} onClick={() => setExcellUploadModalOpen(true)} />
              <CustomButton title="Add Candidate" className="btn abc font-poppins text_sm text_medium" rightIcon={<Image src={PlusIcon} />} onClick={() => setDrawerOpen(true)} />
              {selectedCandidates.length > 0 && (
                <CustomButton title={`Schedule Interview (${selectedCandidates.length})`} className="btn font-poppins text_sm text_medium" onClick={() => handleScheduleInterview()} />
              )}
            </>

          )}

        </Flex>
      </Flex>
      <Grid className="grid_container">
        <GridItem colSpan={12}>
          <Box position="relative" minH="300px">
            {loading ? (
              <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
              </Center>

            ) : (
              <>
                <CustomTable value={candidateList}  >
                  {!hideAddButton && <Column header={
                    // Show header checkbox only if there is  status === 1 means applied status
                    candidateList.some((c: any) => c.status === 1) ? (
                      <input
                        type="checkbox"
                        checked={
                          selectableCandidates.length > 0 &&
                          selectableCandidates.every((c: any) =>
                            selectedCandidates.includes(c.id)
                          )
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            // SELECT ALL
                            setSelectedCandidates(selectableCandidates.map((c: any) => c.id));
                          } else {
                            // UNSELECT ALL
                            setSelectedCandidates([]);
                          }
                        }}
                      />

                    ) : null
                  }
                    body={(row: any) =>
                      row.status === 1 && row.canWork ? (
                        <input type="checkbox" checked={selectedCandidates.includes(row.id)} onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedCandidates((prev) => [...prev, row.id]);
                          } else {
                            setSelectedCandidates((prev) => prev.filter((id) => id !== row.id));
                          }
                        }}
                        />
                      ) : null // Hide checkbox for other statuses
                    }
                  />}
                  <Column header="S. No" body={(_, index) => index + 1} />
                  <Column header="Candidate Name" body={(row: any) => {
                    const canWork = row.canWork;
                    return (
                      <>
                        <Tooltip label={!canWork ? "You do not have permission to view details" : ""} isDisabled={canWork} >
                          <Badge variant="subtle" className="jobTitle font-poppins text_sm text_regular" cursor={canWork ? "pointer" : "not-allowed"} opacity={canWork ? 1 : 0.4} onClick={canWork ? () => candidateDetails(row) : undefined} >
                            {row.candidate_Name}
                          </Badge>
                        </Tooltip>

                      </>
                    );
                  }}
                  />

                  <Column header="Job Role" field="job_Profile_Name" />
                  <Column header="Experience (in Months)" body={(row: any) => (row.experience_In_Month === 0 ? "Fresher" : row.experience_In_Month)} />
                  <Column header="Interview Detail" body={(rowData: any) => (<Text className="font-poppins text_sm text_regular" cursor="pointer" color={"green.500"} onClick={() => { setInterviewDetailsModal(true); setSelectedInterviewDetails(rowData); }} > View</Text>)} />
                  {/* <Column header="Hiring Category" body={(row: any) => (
                    row.hiring_Category === 1 ? "Sourcing" : row.hiring_Category === 2 ? "Campus" : row.hiring_Category === 3 ? "Walk-in " : row.hiring_Category === 5 ? "Re-Applied" : row.hiring_Category === 4 ? "Referral" : "-"
                  )} /> */}
                  <Column header="Hiring Category" body={(row: any) => {
                    const categoryText = row.hiring_Category === 1 ? "Sourcing" : row.hiring_Category === 2 ? "Campus" : row.hiring_Category === 3
                      ? "Walk-in" : row.hiring_Category === 4 ? "Referral" : row.hiring_Category === 5 ? "Re-Applied" : "-";
                    const assignedHr = row.assignedHrName;
                    if ((row.hiring_Category === 4 || row.hiring_Category === 5) && assignedHr) {
                      return (
                        <Tooltip
                          label={`Assigned HR: ${assignedHr}`}
                          hasArrow placement="top" bg="gray.700" color="white"
                          fontSize="sm" px={3} py={2} borderRadius="md"
                        >
                          <Text cursor="pointer" color="blue.600" fontWeight="500">
                            {categoryText}
                          </Text>
                        </Tooltip>
                      );
                    }
                    return <Text>{categoryText}</Text>;
                  }}
                  />


                  <Column header="Status" body={(row: any) => {
                    const isRejected = row.result === "Rejected";
                    const isHold = row.result === "Hold";
                    const tooltipLabel = isRejected && row.rejected_Reason ? row.rejected_Reason : isHold && row.hold_Reason ? row.hold_Reason : "";

                    return (
                      <Tooltip label={tooltipLabel} isDisabled={!tooltipLabel} hasArrow placement="top" bg="gray.700" color="white" fontSize="sm" px={3} py={2} borderRadius="md" >
                        <Badge backgroundColor={row.result === "Accepted" ? "#E5F2E5" : row.result === "Rejected" ? "#FF00001A" : row.result === "Interview Scheduled" ? "#FF00001A" : row.result === "Shortlisted" ? "#1494141A" : "#FFFF001A"}
                          color={row.result === "Accepted" ? "#008000" : row.result === "Rejected" ? "#FF0000" : row.result === "Interview Scheduled" ? "#800080" : row.result === "Shortlisted" ? "#149414" : "#FFA500"}
                          px={3}
                          py={1}
                          borderRadius="6px"
                          cursor={tooltipLabel ? "pointer" : "default"}
                        >
                          <Text className="font-poppins text_regular text_sm">
                            {row.result}
                          </Text>
                        </Badge>
                      </Tooltip>
                    );
                  }}
                  />
                  <Column header="Submitted By" field="recruiter" />
                  <Column header="Action" body={(row: any) => {
                    const canWork = row.canWork;
                    const AppliedStatus = row.status === 1 && row.created_By_Id === employeeId;

                    return (
                      <Box display="flex" alignItems="center" gap={3}>
                        <Tooltip label={!canWork ? "You do not have permission to view details" : ""} isDisabled={canWork} >
                          <Image src={ArrowIcon} alt="View" cursor={canWork ? "pointer" : "not-allowed"} opacity={canWork ? 1 : 0.4} onClick={canWork ? () => candidateDetails(row) : undefined} />
                        </Tooltip>
                        {canWork && AppliedStatus && <ActionEditIcon onClick={() => { setSelectedCandidate(row); onOpen(); }} />}
                        {ivrAccess && <Tooltip label="Call History" placement="top">
                          <IconButton aria-label="View History" icon={<TimeIcon />} size="md" variant="ghost" colorScheme="green" onClick={() => openCallHistory(row)} />
                        </Tooltip>}

                        {ivrAccess && <Tooltip label="Call" placement="top">
                          <IconButton aria-label="call" icon={<PhoneIcon />} size="sm" variant="ghost" colorScheme="blue" onClick={() => triggerCall(row)} />

                        </Tooltip>}
                      </Box>
                    );
                  }}
                  />
                </CustomTable>
                <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick} rowsPerPage={query.lazyParams.rows} setRowsPerPage={setRowsPerPage} totalRecords={totalCount} currentPage={query.lazyParams.page} rowsPerPageOptions={[20, 50, 200, 500]} />

              </>)}
          </Box>
        </GridItem>
      </Grid>
      {/*------------ calling Modal ------------ */}
      <Modal isOpen={callModalOpen} onClose={endCall} isCentered size="sm">
        <ModalOverlay bg="blackAlpha.400" backdropFilter="blur(3px)" />

        <ModalContent borderRadius="18px" py={8} textAlign="center" overflow="visible">
          <CallModal>
            <ModalBody>

              <Flex direction="column" align="center" justify="center" mt={6}>
                <Text className="font-poppins text_xl text_semibold">
                  {callingCandidate?.candidate_Name}
                </Text>

                <Text mt={2} color="gray.600" className="font-poppins text_md text_medium">
                  Calling ...
                </Text>

                <Box mt={6} >
                  <Box className="pulse">
                    <Image src={CallImage} w="38px" h="38px" />
                  </Box>
                </Box>
              </Flex>

              <Button
                mt={8}
                colorScheme="red"
                borderRadius="full"
                px={5}
                onClick={endCall}
                leftIcon={<PhoneIcon />}
              >
                End Call
              </Button>

            </ModalBody>
          </CallModal>
        </ModalContent>
      </Modal>

      {/*------------- History Drawer ----------------*/}
      <Drawer isOpen={historyDrawer} placement="right" onClose={() => setHistoryDrawer(false)} size="lg">
        <DrawerOverlay />
        <DrawerContent>

          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">
            Call History — {historyCandidate?.candidate_Name}
          </DrawerHeader>

          <DrawerBody>

            {historyLoading ? (
              <Center h="200px">
                <Spinner />
              </Center>
            ) : (
              <CustomTable value={callHistory}>
                <Column header="Call Date" body={(row: any) => showDate(row.callDate)} />
                <Column header="Customer Number" field="customerNumber" />
                <Column header="Agent Number" field="agentNumber" />
                <Column header="Agent Name" field="employeeName" />
                <Column header="Call Start Time" field="startTime" />
                <Column header="Call End Time" field="endTime" />
                <Column header="Duration" body={(row: any) => formatDuration(row.duration)} />
                <Column header="Status" body={(row: any) => (<Badge> {row.status} </Badge>)} />
                <Column header="Direction" body={(row: any) => (<Badge> {row.callDirection} </Badge>)} />

                <Column
                  header="Play"
                  body={(row: any) =>
                    row.recordingUrl ? (
                      // <Button size="sm" colorScheme="green" isLoading={audioLoading && audioModalOpen === false} onClick={() => playRecording(row.recordingUrl)}>
                      //   Play
                      // </Button>
                      <IconButton aria-label="call" icon={<Image src={AudioPlayIcon} />} size="sm" variant="ghost" colorScheme="blue" isLoading={loadingRecording === row.recordingUrl}
                        onClick={() => playRecording(row.recordingUrl)} />

                      // <Image src={AudioPlayIcon} isLoading={audioLoading && audioModalOpen === false} onClick={() => playRecording(row.recordingUrl)}/>
                    ) : (
                      "-"
                    )
                  }
                />

              </CustomTable>
            )}

          </DrawerBody>
        </DrawerContent>
      </Drawer>



      <Drawer isOpen={drawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="lg">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader borderBottomWidth="1px">Add New Candidate</DrawerHeader>

          <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <Box py={4} as="form" onSubmit={handleSubmit(onSubmit)}>
              <Flex gap={2}>
                <HrlenseInput isRequired name="name" label="Candidate Name" control={control} errors={errors} placeholder="Enter candidate name" />
                <Dropdown isRequired name="gender" label="Gender" control={control} errors={errors} placeholder="Select Gender" options={genderList} labelKey="gender" valueKey="id" />
              </Flex>

              <Flex gap={2} mt={2}>
                <HrlenseInput isRequired name="email" label="Email" control={control} errors={errors} placeholder="Enter Email" type="email" />
                <FormControl isInvalid={!!errors.confirm_email} isRequired>
                  <FormLabel>Re Enter Email</FormLabel>
                  <Controller name="confirm_email" control={control} render={({ field }) => (
                    <Input {...field} value={field.value || ""} placeholder="Confirm Email" type="email" autoComplete="new-email"
                      onCopy={(e) => e.preventDefault()} onCut={(e) => e.preventDefault()} onPaste={(e) => e.preventDefault()} onDrop={(e) => e.preventDefault()} onContextMenu={(e) => e.preventDefault()}
                    />)} />
                  <FormErrorMessage>
                    {errors.confirm_email && errors.confirm_email.message}
                  </FormErrorMessage>
                </FormControl>
              </Flex>
              <Flex gap={2} mt={2}>
                <HrlenseInput isRequired name="phone" label="Phone Number" maxLength={10} control={control} errors={errors} placeholder="Enter Phone No." type="tel" />
                <HrlenseInput isRequired name="current_Location" label="Current Location" control={control} errors={errors} placeholder="Enter Current Location" type="text" />
              </Flex>

              <Flex gap={2} mt={2}>
                <Dropdown isRequired name="work_Mode" label="Work Mode" control={control} errors={errors} placeholder="Select Work Mode" options={workModeList} labelKey="work_Mood" valueKey="id" />
                <Dropdown isRequired name="hiring_Category" label="Hiring Category" control={control} errors={errors} placeholder="Select Hiring Category" options={hiringCategoryList} labelKey="category" valueKey="id" />
              </Flex>

              <Flex gap={1} mt={2}>
                <Dropdown isRequired name="experience" label="Experience" control={control} errors={errors} placeholder="Select Experience" options={experince} labelKey="label" valueKey="value" />
              </Flex>

              {isExperienceCheck === true && (
                <>
                  <Flex gap={2} mt={2}>
                    <HrlenseInput isRequired name="experience_In_Months" label="Experience (Months)" control={control} errors={errors} placeholder="Enter Experience (Months)" type="number" />
                    <HrlenseInput isRequired name="current_Salary" label="Current Salary (Monthly in ₹)" control={control} errors={errors} placeholder="Enter Current Salary" type="number" />
                  </Flex>
                  <Flex gap={2} mt={2}>
                    <HrlenseInput isRequired name="expected_Salary" label="Expected Salary (Monthly in ₹)" control={control} errors={errors} placeholder="Enter Expected Salary" type="number" />
                    <HrlenseInput isRequired name="notice_Period" label="Notice Period (Days)" control={control} errors={errors} placeholder="Enter Notice Period" type="number" />
                  </Flex>
                </>
              )}

              <Flex gap={2} mt={2}>
                <FormControl mb={4} isRequired >
                  <FormLabel>Upload Resume</FormLabel>
                  <InputGroup>
                    <InputLeftElement width="auto" px={2}>
                      <Button as="label" onClick={handleFileClick} size="sm" colorScheme="gray" leftIcon={<Image src={UploadLogo} />} cursor="pointer" borderRadius="md" w="100%" className="font-poppins text_sm text_regular" >
                        Upload
                      </Button>
                    </InputLeftElement>
                    <Input className="font-poppins text_sm text_regular" placeholder="No file chosen" value={resumeFile ? resumeFile.name : ""} isReadOnly pl="120px" />
                    <input type="file" accept="application/pdf" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
                  </InputGroup>
                </FormControl>
              </Flex>

              <Box>
                <Flex gap={3} justify="flex-end">
                  <CustomButton type="submit" title="Submit" className="font-poppins text_sm text_medium btn_theme btn_theme:hover" />
                </Flex>
              </Box>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      <Modal isOpen={interviewDetailsModal} onClose={() => setInterviewDetailsModal(false)} size="lg" isCentered >
        <ModalOverlay />
        <ModalContent borderRadius="12px">
          <ModalHeader fontSize="lg" fontWeight="600">
            Interview Details
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody pb={6}>
            {selectedInterviewDetails && (
              <Box display="flex" flexDirection="column" gap={4}>
                <Box>
                  <Text fontSize="sm" color="gray.500">Candidate Name:</Text>
                  <Text fontSize="md" fontWeight="600">{selectedInterviewDetails.candidate_Name}</Text>
                </Box>
                <Divider />
                <Box>
                  <Text fontSize="sm" color="gray.500">Interview Date</Text>
                  <Text fontSize="md" fontWeight="500">{selectedInterviewDetails.interview_Date ? showDate(selectedInterviewDetails.interview_Date) : "Not Scheduled"}</Text>
                </Box>
                <Box>
                  <Text fontSize="sm" color="gray.500">Interview Time</Text>
                  <Text fontSize="md" fontWeight="500">{selectedInterviewDetails.interview_Time ? selectedInterviewDetails.interview_Time : "Not Scheduled"}</Text>
                </Box>
                <Box>
                  <Text fontSize="sm" color="gray.500">Interview Mode</Text>
                  <Text fontSize="md" fontWeight="500">{selectedInterviewDetails.interview_Mode ? selectedInterviewDetails.interview_Mode : "Not Scheduled"}</Text>
                </Box>
                <Divider />
                <Box>
                  <Text fontSize="sm" color="gray.500" mb={2}>Interviewers</Text>
                  {selectedInterviewDetails.interviewers &&
                    selectedInterviewDetails.interviewers.length > 0 ? (
                    <Flex wrap="wrap" gap={2}>
                      {selectedInterviewDetails.interviewers.map(
                        (interviewer: any, index: number) => (
                          <Badge key={index} px={3} py={1} borderRadius="full" fontSize="12px" colorScheme="blue" > {interviewer.interviewer_Name} </Badge>
                        )
                      )}
                    </Flex>
                  ) : (
                    <Text fontSize="sm" color="gray.400">
                      No interviewers assigned
                    </Text>
                  )}
                </Box>
              </Box>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>


      <Modal isOpen={audioModalOpen} onClose={closeAudioModal} size="md" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="12px">
          <ModalHeader>Call Recording Player</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Box display="flex" flexDirection="column" alignItems="center" gap={4}>
              <Text className="font-poppins text_medium text_md">
                Playing recording for {historyCandidate?.candidate_Name}
              </Text>
              <audio controls autoPlay src={audioUrl} style={{ width: "100%" }}>
                Your browser does not support the audio element.
              </audio>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>

      <ScheduleMultipleInterview isModalOpen={isModalOpen} handleCloseModal={handleCloseModal} jobId={jobId} selectedCandidateDetails={selectedCandidateDetails} setSelectedCandidateDetails={setSelectedCandidateDetails} loadCandidateList={loadCandidateList} />
      <BulkExcellUpload excellModalOpen={excellUploadModalOpen} setExcellUploadModalOpen={setExcellUploadModalOpen} jobId={jobId} loadCandidateList={loadCandidateList} />
      <BulkResumeUpload resumeModalOpen={resumeUploadModalOpen} setResumeUploadModalOpen={setResumeUploadModalOpen} jobId={jobId} loadCandidateList={loadCandidateList} />
      <EditCandidateDetails selectedCandidate={selectedCandidate} isOpen={isOpen} onClose={onClose} jobId={jobId} loadCandidateList={loadCandidateList} />
    </MyDiv >
  );
};

export default CandidateList;

